import { PlatformerLevel } from '../../shared/CharacterTypes';
import { MAP_DEFAULTS } from '../../config/map/defaults.config';
import { GridLevel, LayerType } from '../../shared/TileEditorTypes';
import { W, H, T } from './StarterMap'; // Reuse dimensions

const MAP_ID = 'tutorial-island';
const MAP_NAME = 'Tutorial Island';
const VERSION = '1.0';

const groundLayer = new Map<string, number>();
const collisionLayer = new Map<string, number>();
const objectsLayer = new Map<string, number>();
const entitiesLayer = new Map<string, number>();
const triggersLayer = new Map<string, number>();

// Put Guide Rafael at x=400, y=500
const entities: any[] = [
  {
    type: 'guide_rafael',
    x: 400,
    y: 500, // Ground level
    properties: {}
  }
];

const spawnPoints = [
  { x: 300 / T, y: 500 / T } // Spawn player near the Guide
];

const defaultSpawn = {
  x: 300,
  y: 500
};


// A clean simple ground
const runtimePlatforms: any[] = [
  {
    id: 'tutorial-ground',
    x: 0,
    y: 500,
    width: W * T,
    height: MAP_DEFAULTS.ground.height,
    type: 'normal',
    color: MAP_DEFAULTS.ground.color
  }
];

export const TutorialIsland: GridLevel & Partial<PlatformerLevel> = {
  id: MAP_ID,
  name: MAP_NAME,
  version: VERSION,
  widthTiles: W,
  heightTiles: H,
  width: W * T,
  height: H * T,
  tileSize: T,
  backgroundColor: '#87CEEB', // Sky blue for welcoming feel
  gravity: MAP_DEFAULTS.gravity,

  spawnPoints,
  defaultSpawn,

  layers: [
    {
      name: LayerType.GROUND,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: groundLayer
    },
    {
      name: LayerType.COLLISION,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: collisionLayer
    },
    {
      name: LayerType.OBJECTS,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: objectsLayer
    },
    {
      name: LayerType.ENTITIES,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: entitiesLayer,
      entities
    },
    {
      name: LayerType.TRIGGERS,
      visible: true,
      locked: false,
      opacity: 1.0,
      tiles: triggersLayer
    }
  ],

  platforms: runtimePlatforms,
  spawnRules: [], // No hostile mobs spawn
  type: 'town',
  metadata: {
    author: 'Helix2000 System',
    description: 'The safe starting zone for all new players.',
    difficulty: 'Low',
    maxPlayers: 10,
    version: '1.0',
    tags: ['tutorial', 'safe-zone', 'starting-map'],
    // Strict safe-zone — `lobby_safe` profile with NO overrides.
    // PvP cannot be enabled here; bots ignore players. New-player
    // first-impression sanctity is the load-bearing invariant.
    profile: 'lobby_safe',
  }
};
